import { render, staticRenderFns } from "./dashboardList.vue?vue&type=template&id=6b5cde2e&"
import script from "./dashboardList.vue?vue&type=script&lang=js&"
export * from "./dashboardList.vue?vue&type=script&lang=js&"
import style0 from "./dashboardList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports